import InputSearch from "../../../../components/inputs/InputSelectSearch";
import { Row, Col } from "react-bootstrap";
import InputNumber from "../../../inputs/InputNumber";

const AddresForm = ({
  values,
  errors,
  touched,
  onChange,
  handleBlur,
  regiones,
  areas,
  distritos,
}: {
  values: any;
  errors: any;
  touched: any;
  onChange: any;
  handleBlur: any;
  regiones: any;
  areas: any;
  distritos: any;
}) => {
  return (
    <div>
      <Row className="d-flex justify-content-around mt-3">
        <Col xs={12} md={3}>
          <InputSearch
            label="Región"
            name="region"
            value={values.region as string}
            touched={touched.region}
            error={errors.region}
            values={regiones}
            labelVal="name"
            valueVal="_id"
            onChangeMethod={onChange}
            onBlurMethod={handleBlur}
          />
        </Col>
        <Col xs={12} md={3}>
          <InputSearch
            label="Distrito"
            name="distrito"
            value={values.distrito as string}
            touched={touched.distrito}
            error={errors.distrito}
            values={distritos}
            labelVal="name"
            valueVal="_id"
            onChangeMethod={onChange}
            onBlurMethod={handleBlur}
            disabled={!values.region || regiones.length === 0 ? true : false}
          />
        </Col>
        <Col xs={12} md={3}>
          <InputSearch
            label="Órgano jurisdiccional"
            name="area"
            value={values.area as string}
            touched={touched.area}
            error={errors.area}
            values={areas}
            labelVal="name"
            valueVal="_id"
            onChangeMethod={onChange}
            onBlurMethod={handleBlur}
            disabled={!values.distrito || areas.length === 0 ? true : false}
          />
        </Col>
        
      </Row>

      {(values.typeDocument === "acuerdos" || values.typeDocument === "sentencias") && (
        <div className="d-flex flex-row d-flex justify-content-center">
          <div className="">
            <InputNumber
              label="Expendiente"
              name="number"
              value={values.number}
              touched={touched.number}
              error={errors.number}
              onChangeMethod={onChange}
              onBlurMethod={handleBlur}
              disableSep
            />
          </div>
          <p className="mt-4 fs-3 mx-1">/</p>
          <div className=" mt-2">
            <InputNumber
              label=""
              name="year"
              value={values.year}
              touched={touched.year}
              error={errors.year}
              onChangeMethod={onChange}
              onBlurMethod={handleBlur}
              disableSep
              maxLength={4}
            />
          </div>
        </div>
      )}

      <Row className="d-flex justify-content-around mt-3"></Row>
    </div>
  );
};

export default AddresForm;
